import { useMutation } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { postPayoutsPostAuthV2, postPayoutsV2PreAuth } from 'services/PayoutsService'
import { BaseErrorResponse } from 'types/beneficiaries'

export const usePayoutsV2PreAuthMutation = () => {
  return useMutation({
    mutationFn: postPayoutsV2PreAuth,
    onError: (error, data) => {
      logSentryError('Error: usePayoutsV2PreAuthMutation', error, data)
    },
  })
}

export const usePayoutsV2PostAuthMutation = () => {
  return useMutation({
    mutationFn: postPayoutsPostAuthV2,
    onError: (error: BaseErrorResponse, data) => {
      if (error?.status !== 403) {
        logSentryError('Error: usePayoutsV2PostAuthMutation', error, data)
      }
    },
  })
}
